<template>
  <div class="webim-aio webim-aio-pc">
    <div class="im-position-container" :style ="listBgStyle">
      <!-- 消息列表前slot -->
      <slot name="beforeMsgList"></slot>
      <div class="im-message-container page-scroll-container" @scroll="scrollChange"
        >
        <msg-new-notice :nums="notReadNumber" @click="scrollToBottom"></msg-new-notice>
        <msg-load v-if="isMoreMessage" :isLoading="isLoading" @click="onHistoryMessageClick()"></msg-load>
        <message-list
          :msgList="messageList"
          :styleConfig="styleConfig"
          style="padding:8px 12px 0px;"
          @resendMsg="resendMessage"
          @onReplay="replay"
          @onCopy="handleCopyMsg"
          @onRevoke="revokeMsg"
          @on-scroll-to="handleReplayMsgClick"
          @onLunchQQ="msg => $emit('onLunchQQ', msg)"
          @onAddQQ="msg => $emit('onAddQQ', msg)"
          @videoMsgClick="msg => $emit('videoMsgClick', msg)"

        >
          <template #thirdMsgItem="slotProps">
            <slot name="thirdMsgItem" :data="slotProps.data"></slot>
          </template>
        </message-list>
        <div ref="scrollToBottom"></div>
      </div>
      <!-- 消息列表后slot -->
      <slot name="afterMsgList"></slot>
    </div>
    <!-- 底部工具栏 --><!-- 未就绪时，工具栏不可用。 -->
    <chat-tools ref="chatTools" class="im-chat-tools" :class="isIMReady? '' : 'tools-disabled'"
      :toolButtons="toolButtons"
      :inputContent.sync="sendContent"
      :source-msg="sourceMsg"
      @on-delete-source-msg="sourceMsg = null"
      @clickToolBtn="(arg)=>$emit('clickToolBtn', arg)"
      @callFunc="onCallFunc"
    >
    </chat-tools>
    <div class="shadow-container">
      <image-uploader ref="imageUploader" @preview="onPreviewImage" @upload="onSendImageMessage"></image-uploader>
        <!-- 文件表单 -->
      <file-uploader ref="fileUploader"
        @preview="onPreviewFile" @progress="onFileProgress" @upload="onSendFileMessage"></file-uploader>
    </div>
    <qd-sign v-if="isIMReady && inIframe" :wpaDetail="JSON.stringify(wpaDetail)"> </qd-sign>
    <mock-msg :to="to"></mock-msg>

    <!-- aio 内容最后 slot -->
    <slot name="last"></slot>
    <!-- 设置语言弹窗 -->
    <set-lang-modal v-if="isShowSetLangPanel"></set-lang-modal>
    <!-- 表单 -->
    <information-form-pc ref="consultForm"></information-form-pc>
  </div>
</template>

<script>
import QdSign from '@/components-business/QdSign';
import ChatTools from '../ChatTools';
import ImageUploader from '@/components/ImageUploader';
import FileUploader from '@/components/FileUploader';
import MsgLoad from '../MsgLoad';
import MessageList from '../MessageList';
import MockMsg from '@/components/MockMsg';
import MsgNewNotice from '../MsgNewNotice';
import SetLangModal from '@/components-business/SetLangModal';
import InformationFormPc from '@/components/InformationForm/InformationFormPC';

import MixinSendMsg from '@/components/MixinSendMsg.js';
import MixinTestMsg from '@/components/MixinTestMsg.js';

import globalWin from '@/utils/globalWin';

export default {
  name: 'Aio',
  // provide() {
  //   return {
  //     transferRobotMsg: this.transferRobotMsg.bind(this),
  //   };
  // },
  mixins: [MixinSendMsg, MixinTestMsg],
  // inject: ['seqMessageMap'],
  components: {
    ChatTools,
    ImageUploader,
    FileUploader,
    MsgLoad,
    MessageList,
    MockMsg,
    MsgNewNotice,
    QdSign,
    SetLangModal,
    InformationFormPc,
  },
  data() {
    return {
      isShowSetLangPanel: false,
    };
  },
  created() {
    globalWin.switchSetLangPanel = this.switchSetLangPanel.bind(this);
  },
  methods: {
    replay(msg) {
      this.handleReplayMsg(msg);
      this.$refs.chatTools.focus && this.$refs.chatTools.focus();
    },
    switchSetLangPanel(val) {
      this.isShowSetLangPanel = val;
    },
    // 传递robotMsg的信息到B测
    // transferRobotMsg(msg) {
    //   console.log('transferRobotMsg', msg);
    //   this.$emit('transferRobotMsg', msg);
    // },
  },
};
</script>

<style lang="less" scoped>
.webim-aio{
  flex: 1;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  position: relative;
}

.im-position-container{
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  border-bottom: 1px solid #efeff4;

  background-size: cover;
  background-position: 50%;
}

.im-message-container{
  flex:1;
  overflow-x:hidden;
  overflow-y:scroll;
}

.shadow-container{
  position: absolute;
  width: 0px;
  height: 0px;
  overflow: hidden;
}

.tools-disabled{
  opacity: 0.7;
  pointer-events: none;
}
</style>
